import { render, staticRenderFns } from "./ModalMostrarProgramaUniversidadV2.vue?vue&type=template&id=285e380e&scoped=true"
import script from "./ModalMostrarProgramaUniversidadV2.vue?vue&type=script&lang=js"
export * from "./ModalMostrarProgramaUniversidadV2.vue?vue&type=script&lang=js"
import style0 from "./ModalMostrarProgramaUniversidadV2.vue?vue&type=style&index=0&id=285e380e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285e380e",
  null
  
)

export default component.exports